import styled from 'styled-components';

export const Container = styled.div`
  padding: ${({ theme }) => theme.spacing[8]};
`;
